import { Injectable, Inject } from '@angular/core';
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";
import { Response, RequestOptions, ResponseContentType, Http } from '@angular/http';
import { ToastrService } from "ngx-toastr";
import { environment } from '../../../../environments/environment';
import { ContainerListData } from '../../models/container-list-data.interface';
import { PlanningBlock } from '../../../pb-screen/models/planning-block/planning-block.interface';
import { HttpClientService } from '../httpclient';


@Injectable()
export class ContainerListService {

  public baseUrl: string = environment.ContainerPlanningApiUri + "print";


    constructor(
        private readonly http: HttpClientService,
        private readonly toastr: ToastrService,
    ) { }


  public printContainerList(pbs: PlanningBlock[], name: string, type: number): any {
    const data: ContainerListData = {
      planningBlocks: [],
      name: "",
      type: {
        iD: type,
      },
    };


    data.planningBlocks = pbs.sort((a, b) => {
      if (a.closingDate.toString().split(" ")[0].split("/").reverse().join() >
        b.closingDate.toString().split(" ")[0].split("/").reverse().join()) { return 1; }
      if (a.closingDate.toString().split(" ")[0].split("/").reverse().join() <
        b.closingDate.toString().split(" ")[0].split("/").reverse().join()) { return -1; }

      if (a.fileId > b.fileId) { return -1; }
      if (a.fileId < b.fileId) { return 1; }
    });

    data.name = name;

    var fileType = "application/pdf";
    if (type == 2) //It is excel 
    {
      fileType = "application/excel";

    }

    return this.http.post(this.baseUrl + "/containerlist", data, 'blob')
      .map((res: any) => {
        var data = window.URL.createObjectURL(res);
        if (type == 1) {
          window.open(data);
        }
        else {
          var link = document.createElement('a');
          link.href = data;

          var fileName = "ContainersList.xlsx";
          link.download = fileName;
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);
        }

      }
      )
      .catch((err) => {
        //this.(err);
        return Observable.throw(err);
      });
  }


}
